import useMonthlyUsage from './hooks/useMonthlyUsage';

import {
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    TableCell,
    TablePagination
} from '../../../../components/ui/table';

import { Alert, AlertTitle, AlertDescription } from '../../../../components/ui/alert';
import { TableSkeleton } from '../../../../components/TableSkeleton';

interface MonthlyUsageTableProps { }

const MonthlyUsageTable = (props: MonthlyUsageTableProps) => {

    const {
        data,
        loading,
        error,
        currentPage,
        totalPages,
        goToPage,
        convertYYYYMM,
        limit,
        setLimit
    } = useMonthlyUsage({ initialLimit: 10 });

    if (error) {
        return (
            <Alert variant="danger">
                <AlertTitle>Error</AlertTitle>
                <AlertDescription>{error}</AlertDescription>
            </Alert>
        );
    }

    if (!loading && (!data || data.length === 0)) {
        return (
            <Alert variant="info">
                <AlertDescription>No monthly usage data available yet.</AlertDescription>
            </Alert>
        );
    }

    return (
        <div className="card-body py-3">
            <Table>
                <TableHeader>
                    <TableHead width="150px" className="ps-4">Month</TableHead>
                    <TableHead width="100px">Total Usage</TableHead>
                </TableHeader>

                {loading ? (
                    <TableSkeleton columns={2} rows={5} />
                ) : (
                    <TableBody>
                        {data.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell className="ps-4">
                                    <span className="text-dark fw-bolder text-hover-primary d-block fs-6">
                                        {convertYYYYMM(item.month)}
                                    </span>
                                </TableCell>
                                <TableCell>
                                    <span className="text-gray-800 fw-bolder d-block fs-6">
                                        ${item.totalCost.toFixed(2)}
                                    </span>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                )}
            </Table>


            {!loading && totalPages > 1 && (
                <TablePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={goToPage}
                    limit={limit}
                    onLimitChange={setLimit}
                />
            )}
        </div>
    );
};

export default MonthlyUsageTable;